// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2aLLT","image":"Header_image__3jUk7","name":"Header_name__nmvfj","info":"Header_info__5BobK","infoRow":"Header_infoRow__t7fA-"};